import { CssBaseline, ThemeProvider } from "@mui/material";
import { API, Auth, graphqlOperation, Hub, I18n } from "aws-amplify";
import React from "react";
import { getUserProfile } from "./graphql/queries";
import "./App.css";
import { AppContext } from "./AppContext";
import AppFooter from "./components/AppFooter";
import AppHeader from "./components/AppHeader";
import theme from "./components/mainTheme";
import About from "./pages/About";
import AvailableJobs from "./pages/AvailableJobs";
import FourOhFour from "./pages/FourOhFour";
import Home from "./pages/Home";
import Login from "./pages/Login";
import MyPage from "./pages/MyPage";
import MyProfile from "./pages/MyProfile";
import Register from "./pages/Register";
import ShownInterest from "./pages/ShownInterest";
import { ROUTES } from "./Routes";
import getRouteAndParams from "./utils/getRouteAndParams";

import Select from "@mui/material/Select";

import MenuItem from "@mui/material/MenuItem";
I18n.setLanguage("sv");
const dict = {
  sv: {
    "Sign Out": "Logga ut",
    Confirm: "OK",
    Username: "Användarnamn",
    "Username *": "Epost *",
    "Password *": "Lösenord *",
    "Email Address *": "Epost *",
    "Sign in to your account": "Logga in",
    "Enter your email address": "Ange din epost",
    "Enter your password": "Ange ditt lösenord",
    "Forgot your password?": "Glömt ditt lösenord?",
    "Reset password": "Återställ lösenord",
    "No account?": "Inget konto?",
    "Create account": "Skapa konto",
    "Sign In": "Logga in",
    "Create a new account": "Skapa konto",
    "Phone Number *": "Telefonnummer *",
    "Have an account?": "Har du redan ett konto?",
    "Sign in": "Logga in",
    "Create Account": "Skapa konto",
    "(555) 555-1212": "70 000 00",
    Password: "Lösenord",
    Email: "Epost",
    "Enter your username": "Ange din epost-adress",
    "Invalid phone number format": "Ogiltigt telefonnummer",
    "Username cannot be empty": "Du måste ange epost",
    "Password cannot be empty": "Du måste ange lösenord",
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
      "Lösenordet måste vara minst 6 tecken",
    "Confirm Sign up": "Verifiera din epost",
    "Confirmation Code": "Verifikationskod",
    "Enter your code": "Skriv in din kod",
    "Lost your code?": "Tappat bort din kod?",
    "Resend Code": "Skicka igen",
    "Back to Sign In": "Tillbaks till inloggningssidan",
    "Reset your password": "Återställ lösenord",
    "Back to Sign In ": "Tillbaks till inloggningssidan",
    "Send Code": "Skicka kod",
    "Verification code": "Verifikationskod",
    "Enter code": "Skriv in din kod",
    "New password": "Nytt lösenord",
    "Enter your new password": "Skriv in nytt lösenord",
    Submit: "Spara",
  },
};
I18n.putVocabularies(dict);

export default class App extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    const pathInfo = getRouteAndParams();

    this.state = {
      route: pathInfo.route,
      params: pathInfo.params,
      userData: {},
      authenticated: false,
    };
  }
  async componentDidMount() {
    const hashChange = () => {
      const asdf = getRouteAndParams();

      if (!asdf.route) {
        asdf.route = ROUTES.LOGIN;
      }

      if (this.state.authenticated === true && asdf.route === ROUTES.LOGIN) {
        window.location.href = ROUTES.AVAILABLE_JOBS;
      } else {
        this.setState(asdf);
      }
    };
    window.addEventListener("hashchange", hashChange);

    hashChange();
    if (!window.location.hash) {
      window.location = ROUTES.LOGIN;
    }

    const authChanges = async (event) => {
      try {
        if (event.payload.data.code === "NotAuthorizedException") {
          alert("Felaktigt inloggningsförsök, försök igen");
        } else if (event.payload.data.code) {
          alert(event.payload.data.message);
        }
      } catch (e) {}

      if (event)
        if (event && event.payload && event.payload.event === "signOut") {
          //Clear user profile
          setTimeout(() => {
            this.setState({ authenticated: false });
            this.setState({ userProfile: null });
            this.setState({ userData: null });
          }, 1000);
          window.location.href = ROUTES.LOGIN;
        }

      try {
        const obj = await Auth.currentAuthenticatedUser();
        this.setState({ userData: obj.attributes });
        if (obj && obj.attributes && obj.attributes.email) {
          //Set user as authenticated and redirect user to available jobs
          function redirectTo() {
            //Do we have a redirectTo query parameter?
            //otherwise redirect to Available jobs
            const params = getRouteAndParams().params;
            if (params.redirectTo) {
              window.location.href = "#" + params.redirectTo;
            } else {
              window.location.href = ROUTES.AVAILABLE_JOBS;
            }
          }
          this.setState({ authenticated: true }, redirectTo);
        } else {
          this.setState({ authenticated: false });
        }
      } catch (e) {
        this.setState({ authenticated: false });
      }
      //Fetch user profile
      //Listen to changes for user profile
      const fetchUserProfileLocal = async () => {
        try {
          const userProfile = await fetchUserProfile();
          this.setState({ userProfile });
        } catch (e) {}
      };
      //Trigger once to load profile att start
      fetchUserProfileLocal();
      document.addEventListener("jojoo_profileupdated", fetchUserProfileLocal);
      // return obj.attributes.email;
      //  const username = event.payload.data.attributes.email;
    };
    Hub.listen("auth", authChanges);
    authChanges();
  }

  componentDidUpdate() {
    if (
      this.state.authenticated === true &&
      this.state.route === ROUTES.LOGIN
    ) {
      window.location.href = ROUTES.AVAILABLE_JOBS;
      return;
    }

    //Make sure the page is loaded
    setTimeout(() => {
      document.addEventListener("keyup", forceUsernameToLowerCase);
    }, 1000);
  }
  render() {
    return (
      <AppContext.Provider
        value={{
          userProfile: this.state.userProfile,
          authenticated: this.state.authenticated,
        }}
      >
        <div className="App">
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppHeader />

            {this.state.route === "#home" && <Login />}

            {this.state.route !== "#home" && <this.CurrentRoute />}
            {this.state.route !== "#home" && <AppFooter />}
          </ThemeProvider>
        </div>
      </AppContext.Provider>
    );
  }

  CurrentRoute = () => {
    const routes = {
      [ROUTES.ABOUT]: <About />,
      [ROUTES.AVAILABLE_JOBS]: <AvailableJobs />,
      [ROUTES.MY_JOB_REQUESTS]: <MyPage />,
      [ROUTES.MY_PROFILE]: <MyProfile />,
      "#showninterest": <ShownInterest />,
      [ROUTES.LOGIN]: <Login />,
      [ROUTES.REGISTER]: <Register />,
    };

    let hash = this.state.route;

    const userProfile = {};
    //If no user profile and user wants to navigate to my job request
    //send the user to my profile
    if (!userProfile && hash === ROUTES.MY_JOB_REQUESTS) {
      hash = ROUTES.MY_PROFILE;
    }

    //Verify that the user is authenticated
    const authenticatedRoutes = [
      ROUTES.AVAILABLE_JOBS,
      ROUTES.MY_JOB_REQUESTS,
      ROUTES.MY_PROFILE,
      "#showninterest",
    ];
    if (this.state.authenticated === false) {
      if (authenticatedRoutes.indexOf(hash) > -1) {
        hash = ROUTES.LOGIN;
        //Dont redirec while rendering, redirect the next tick
        setTimeout(() => (window.location.href = ROUTES.LOGIN), 0);
      }
    }
    if (routes[hash]) {
      return routes[hash];
    }

    //Default register
    return <FourOhFour />;
  };
}

function forceUsernameToLowerCase(event) {
  try {
    //Only act on amazon login form
    if (event.target.tagName.indexOf("AMPLIFY") === -1) {
      return;
    }

    const a = document.querySelector("amplify-authenticator amplify-sign-in");
    const b = a.shadowRoot.querySelector(
      "amplify-form-section amplify-auth-fields"
    );
    const userNameField = b.querySelector("#username");
    let value = userNameField.value;
    userNameField.value = value.toLowerCase();

    if (value.toLowerCase() !== value) {
      value = value.toLowerCase();
      userNameField.value = value;
    }
  } catch (e) {}
}

const fetchUserProfile = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const id = user.attributes.sub;
  const variables = {
    id,
  };
  const userProfileData = await API.graphql(
    graphqlOperation(getUserProfile, variables)
  );
  return userProfileData.data.getUserProfile;
};
